(() => {
  /* The phone menu leaves the way it came (150 ms; 100 ms fade with reduced motion; header.liquid styles it).
     Every other window closes at once. Without this file the menu's buttons still open and close it
     (command/commandfor in the header snippets), just without the exit. */
  const menu = document.getElementById('menu-drawer'), calm = matchMedia('(prefers-reduced-motion: reduce)');
  let menuOpener = null;
  const shut = dialog => {
    if (!dialog.open) return;
    if (dialog !== menu) { dialog.close(); return; }
    if (menu.classList.contains('is-closing')) return;
    menu.classList.remove('is-dragging'); menu.classList.add('is-closing');
    setTimeout(() => menu.close(), calm.matches ? 100 : 150);
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) { const dialog = document.getElementById(opener.dataset.openDialog); if (dialog && !dialog.open) { dialog.showModal(); dialog.dataset.opener = opener.id || ''; if (dialog === menu) menuOpener = opener; try { window.__voissonHeader?.dialogOpened?.(dialog, opener); } catch (e) { /* optional motion never blocks opening */ } } }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer && closer.closest('dialog')) { event.preventDefault(); shut(closer.closest('dialog')); }
    const cart = event.target.closest('[data-cart-link]');
    if (cart && window.InteractopusCart?.open) { event.preventDefault(); window.InteractopusCart.open(); }
    document.querySelectorAll('.nav-disclosure[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  /* A tap on the dim area beside a window closes it */
  document.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => { const r = dialog.getBoundingClientRect(); if(event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) shut(dialog); }));
  document.addEventListener('keydown', event => { if(event.key === 'Escape') { const dialog = document.activeElement?.closest('dialog[open]') || [...document.querySelectorAll('dialog[open]')].pop(); if(dialog) { event.preventDefault(); shut(dialog); } } }, true);
  if (menu) {
    menu.addEventListener('cancel', event => { event.preventDefault(); shut(menu); });
    menu.addEventListener('close', () => {
      menu.classList.remove('is-closing', 'is-dragging'); menu.style.removeProperty('--md-x'); menu.style.removeProperty('--md-fade');
      const at = document.activeElement;
      if (menuOpener && menuOpener.isConnected && (!at || at === document.body || menu.contains(at))) menuOpener.focus(document.documentElement.hasAttribute('data-io-pointer') ? { preventScroll: true, focusVisible: false } : { preventScroll: true });
    });
    /* A sideways drag (finger or pen) towards the menu's own edge follows the finger; past a third of the width, or a
       quick flick, it closes, otherwise it springs back. A start within 24 px of the left screen edge (and, for a
       right-hand menu, the right edge) is the browser's back or forward swipe.
       out: -1 when the menu sits on the left, 1 when it sits on the right. */
    const out = menu.dataset.side === 'right' ? 1 : -1;
    let start = null, dx = 0, last = null, speed = 0, dragged = -1e4;
    menu.addEventListener('pointerdown', event => {
      start = event.pointerType !== 'mouse' && event.isPrimary && event.clientX >= 24 && (out < 0 || event.clientX <= innerWidth - 24) && !menu.classList.contains('is-closing') ? [event.clientX, event.clientY] : null;
      dx = 0; speed = 0; last = [event.clientX, event.timeStamp];
    });
    menu.addEventListener('pointermove', event => {
      if (!start) return;
      const x = event.clientX - start[0], y = event.clientY - start[1];
      if (!menu.classList.contains('is-dragging')) {
        if (Math.abs(x) < 10 && Math.abs(y) < 10) return;
        if (x * out < 0 || Math.abs(y) >= Math.abs(x)) { start = null; return; }
        menu.classList.add('is-dragging');
      }
      dx = out < 0 ? Math.min(0, x) : Math.max(0, x);
      speed = (event.clientX - last[0]) / Math.max(1, event.timeStamp - last[1]); last = [event.clientX, event.timeStamp];
      if (!calm.matches) { menu.style.setProperty('--md-x', dx + 'px'); menu.style.setProperty('--md-fade', Math.max(0, 1 - Math.abs(dx) / menu.offsetWidth)); }
    });
    const release = event => {
      start = null;
      if (!menu.classList.contains('is-dragging')) return;
      dragged = event.timeStamp;
      if (event.timeStamp - last[1] > 100) speed = 0;
      if (event.type === 'pointerup' && (dx * out > menu.offsetWidth / 3 || speed * out > 0.5)) shut(menu);
      else menu.classList.remove('is-dragging');
    };
    menu.addEventListener('pointerup', release); menu.addEventListener('pointercancel', release);
    menu.addEventListener('click', event => { if (event.timeStamp - dragged < 400) { event.preventDefault(); event.stopPropagation(); } }, true);
  }
  document.querySelectorAll('.nav-disclosure').forEach(details => {
    details.addEventListener('toggle', () => { if(details.open) document.querySelectorAll('.nav-disclosure[open]').forEach(other => { if(other !== details) other.open = false; }); });
    details.addEventListener('keydown', event => { if(event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); } });
  });
  /* The page-to-page glide lives inline in layout/theme.liquid: a deferred file misses pagereveal. */
  /* Back-to-collection timeline box, only with back-debug=1 in the address (recorder: layout/theme.liquid). Shows 4.5 s
     after the page appears (again after a kept page is shown again); a tap on it closes it. Temporary diagnostic. */
  const bd = window.__ioBD;
  if (bd) {
    let box = null;
    const show = () => {
      if (box) box.remove();
      box = document.createElement('pre');
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;z-index:2147483647;left:8px;right:8px;top:8px;max-height:70vh;overflow:auto;margin:0;padding:10px;background:#111;color:#fff;font:11px/1.4 ui-monospace,Menlo,monospace;white-space:pre-wrap;border-radius:8px;opacity:.92';
      box.textContent = 'back-debug (tap to close)\n' + bd.ev.join('\n');
      box.addEventListener('click', () => box.remove());
      document.body.append(box);
    };
    setTimeout(show, 4500);
    addEventListener('pageshow', (e) => { if (e.persisted) setTimeout(show, 4500); });
  }
})();
